import { render, staticRenderFns } from "./Stake.vue?vue&type=template&id=00929906&scoped=true"
import script from "./Stake.vue?vue&type=script&lang=js"
export * from "./Stake.vue?vue&type=script&lang=js"
import style0 from "./Stake.vue?vue&type=style&index=0&id=00929906&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00929906",
  null
  
)

export default component.exports